
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dokument",
      function () {
        return require("private-next-pages/dokument/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dokument"])
      });
    }
  